import axios from "axios";
import React, { useEffect, useState } from "react";
import "./ProfilePage.css";

const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState("addresses");
  const [editing, setEditing] = useState(false);
  const [user, setUser] = useState({
    fullName: "",
    email: "",
    phone: "",
    avatar: "https://placehold.co/100x100",
  });
  const [addresses, setAddresses] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingAvatar, setLoadingAvatar] = useState(false);
  const [newAddressTitle, setNewAddressTitle] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [newPostalCode, setNewPostalCode] = useState("");
  const [expandedOrder, setExpandedOrder] = useState(null);

  // تابع تبدیل اعداد انگلیسی به فارسی
  const convertToPersianNumbers = (num) => {
    return num.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };

  // تابع تبدیل اعداد فارسی به انگلیسی
  const convertToEnglishNumbers = (num) => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const englishDigits = "0123456789";
    return num.replace(
      /[۰-۹]/g,
      (d) => englishDigits[persianDigits.indexOf(d)]
    );
  };

  // دریافت اطلاعات پروفایل از API
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        alert("لطفاً وارد حساب کاربری شوید.");
        window.location.href = "/login-register";
        return;
      }

      try {
        const response = await axios.get(
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/profile",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.is_status) {
          const data = response.data.data;
          setUser({
            fullName: data.full_name,
            email: data.email,
            phone: data.phone,
            avatar: data.avatar || "https://placehold.co/100x100",
          });

          setAddresses(
            data.address.map((addr) => ({
              id: addr.id,
              type: addr.title,
              address: addr.address,
              postalCode: convertToPersianNumbers(addr.post_code),
            }))
          );
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات پروفایل:", error);
        // تغییر اصلی: پاک کردن توکن و ری‌دایرکت به صفحه ورود
        localStorage.removeItem("access_token");
        alert("توکن منقضی شده است. لطفاً دوباره وارد شوید.");
        window.location.href = "/login-register";
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // دریافت اطلاعات سفارشات از وب‌سرویس
  useEffect(() => {
    const fetchOrders = async () => {
      // استفاده از توکن ثابت ارائه‌شده در نمونه وب‌سرویس

      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/user-orders",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.is_status) {
          setOrders(response.data.data);
        }
      } catch (error) {
        console.error("خطا در دریافت سفارشات:", error);
      }
    };

    fetchOrders();
  }, []);

  // تغییر اطلاعات کاربر
  const handleInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  // آپدیت اطلاعات کاربر
  const handleSaveChanges = async () => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        alert("لطفاً ابتدا وارد حساب کاربری شوید.");
        window.location.href = "/login-register";
        return;
      }

      const [firstName, ...lastNameParts] = user.fullName.split(" ");
      const lastName = lastNameParts.join(" ");

      const payload = {
        first_name: firstName,
        last_name: lastName,
        password: "",
        email: user.email,
        phone: user.phone,
        avatar: [
          {
            uri: user.avatar,
            extension: "jpg",
            type: "avatar",
            size: 127450,
            name: "photo_2024-11-09_14-11-05.jpg",
            alt: "photo_2024-11-09_14-11-05.jpg",
            data: null,
          },
        ],
        address: addresses.map((addr) => ({
          title: addr.type,
          post_code: convertToEnglishNumbers(addr.postalCode),
          address: addr.address,
        })),
      };

      const response = await axios.put(
        "https://mediumaquamarine-rat-574365.hostingersite.com/api/update-profile",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.is_status) {
        alert("اطلاعات با موفقیت آپدیت شد!");
        setEditing(false);
      } else {
        alert("آپدیت اطلاعات با خطا مواجه شد.");
      }
    } catch (error) {
      console.error("خطا در آپدیت اطلاعات:", error);
      alert("مشکلی در آپدیت اطلاعات به وجود آمده است.");
    }
  };

  // افزودن آدرس جدید
  const handleAddAddress = async () => {
    if (
      !newAddressTitle.trim() ||
      !newAddress.trim() ||
      !newPostalCode.trim()
    ) {
      alert("لطفاً تمام فیلدهای آدرس را پر کنید.");
      return;
    }

    const token = localStorage.getItem("access_token");
    if (!token) {
      alert("برای افزودن آدرس باید وارد حساب کاربری خود شوید.");
      window.location.href = "/login-register";
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("title", newAddressTitle);
      data.append("address", newAddress);
      data.append("post_code", newPostalCode);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/create-address",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: data,
      };

      const response = await axios.request(config);
      console.log("Create Address Response:", response.data);

      if (response.data.is_status) {
        const newAddrObj = {
          id: response.data.data.id,
          type: newAddressTitle,
          address: newAddress,
          postalCode: convertToPersianNumbers(newPostalCode),
        };

        setAddresses([...addresses, newAddrObj]);
        setNewAddressTitle("");
        setNewAddress("");
        setNewPostalCode("");
        alert("آدرس جدید با موفقیت اضافه شد.");
      } else {
        alert("خطایی در افزودن آدرس رخ داد، لطفاً دوباره تلاش کنید.");
      }
    } catch (error) {
      console.error("Error adding address:", error);
      alert("خطایی در افزودن آدرس رخ داد.");
    } finally {
      setLoading(false);
    }
  };

  // خروج از حساب
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    alert("خروج از حساب انجام شد!");
    window.location.href = "/login-register";
  };

  // آپلود آواتار
  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setLoadingAvatar(true);
      const token = localStorage.getItem("access_token");
      if (!token) {
        alert("لطفاً ابتدا وارد حساب کاربری شوید.");
        window.location.href = "/login-register";
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "avatar");

      const response = await axios.post(
        "https://mediumaquamarine-rat-574365.hostingersite.com/api/uploader",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.is_status) {
        const newAvatarUrl = response.data.data.uri;
        const [firstName, ...lastNameParts] = user.fullName.split(" ");
        const lastName = lastNameParts.join(" ");

        const payload = {
          first_name: firstName,
          last_name: lastName,
          password: "",
          email: user.email,
          phone: user.phone,
          avatar: [
            {
              uri: newAvatarUrl,
              extension: "jpg",
              type: "avatar",
              size: file.size,
              name: file.name,
              alt: file.name,
              data: null,
            },
          ],
          address: addresses.map((addr) => ({
            title: addr.type,
            post_code: convertToEnglishNumbers(addr.postalCode),
            address: addr.address,
          })),
        };

        const updateResponse = await axios.put(
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/update-profile",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (updateResponse.data.is_status) {
          setUser((prev) => ({ ...prev, avatar: newAvatarUrl }));
          alert("عکس پروفایل با موفقیت تغییر کرد!");
        } else {
          alert("آپدیت پروفایل با خطا مواجه شد.");
        }
      } else {
        alert("آپلود آواتار با خطا مواجه شد.");
      }
    } catch (error) {
      console.error("خطا در آپلود آواتار:", error);
      alert("خطا در آپلود آواتار به وجود آمده است.");
    } finally {
      setLoadingAvatar(false);
    }
  };

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner-profile"></div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      {/* دکمه‌های بالای صفحه */}
      <div className="top-buttons">
        <button className="logout-btn" onClick={handleLogout}>
          🚪 خروج
        </button>
        <button
          className="home-btn"
          onClick={() => (window.location.href = "/")}
        >
          🏠 خانه
        </button>
      </div>

      {/* کارت اطلاعات کاربر */}
      <div className="profile-card">
        <label className="avatar-upload">
          {loadingAvatar ? (
            <div className="avatar-loading">
              <div className="spinner"></div>
            </div>
          ) : (
            <img src={user.avatar} alt="آواتار کاربر" className="avatar" />
          )}
          <div className="avatar-overlay">
            <span>📷 تغییر عکس</span>
          </div>
          <input type="file" accept="image/*" onChange={handleAvatarChange} />
        </label>

        {!editing ? (
          <>
            <h2>{user.fullName}</h2>
            <p>{user.email}</p>
            <p>{user.phone}</p>
            <button className="edit-btn" onClick={() => setEditing(true)}>
              ✏️ ویرایش اطلاعات
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              name="fullName"
              value={user.fullName}
              onChange={handleInputChange}
              className="edit-input"
            />
            <input
              type="email"
              name="email"
              value={user.email}
              onChange={handleInputChange}
              className="edit-input"
            />
            <input
              type="text"
              name="phone"
              value={user.phone}
              onChange={handleInputChange}
              className="edit-input"
            />
            <button className="save-btn" onClick={handleSaveChanges}>
              💾 ذخیره تغییرات
            </button>
          </>
        )}
      </div>

      {/* تب‌ها */}
      <div className="tabs">
        <button
          className={activeTab === "addresses" ? "active-tab" : ""}
          onClick={() => setActiveTab("addresses")}
        >
          آدرس‌ها
        </button>
        <button
          className={activeTab === "orders" ? "active-tab" : ""}
          onClick={() => setActiveTab("orders")}
        >
          سفارشات
        </button>
      </div>

      {/* محتوای تب آدرس‌ها */}
      {activeTab === "addresses" && (
        <>
          <div className="address-section">
            <h3>آدرس‌های ثبت‌شده</h3>
            {addresses.length > 0 ? (
              addresses.map((item) => (
                <div
                  key={item.id}
                  className="address-card"
                  style={{ textAlign: "right", direction: "rtl" }}
                >
                  <div className="address-info">
                    <strong>{item.type}</strong>
                    <p>{item.address}</p>
                    <p className="postal-code">کد پستی: {item.postalCode}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-address">هیچ آدرسی ثبت نشده است.</p>
            )}
          </div>

          <div
            className="add-address"
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <input
              type="text"
              placeholder="عنوان آدرس (مثلاً خانه، محل کار...)"
              value={newAddressTitle}
              onChange={(e) => setNewAddressTitle(e.target.value)}
              style={{ textAlign: "right", direction: "rtl" }}
            />
            <input
              type="text"
              placeholder="آدرس جدید را وارد کنید..."
              value={newAddress}
              onChange={(e) => setNewAddress(e.target.value)}
              style={{ textAlign: "right", direction: "rtl" }}
            />
            <input
              type="text"
              placeholder="کد پستی..."
              value={newPostalCode}
              onChange={(e) => setNewPostalCode(e.target.value)}
              style={{ textAlign: "right", direction: "rtl" }}
            />
            <button onClick={handleAddAddress}>افزودن آدرس</button>
          </div>
        </>
      )}

      {/* محتوای تب سفارشات */}
      {activeTab === "orders" && (
        <div
          className="orders-section"
          style={{ textAlign: "right", direction: "rtl" }}
        >
          <h3 className="">سفارش های ثبت‌شده</h3>
          {orders.length > 0 ? (
            orders.map((order, index) => (
              <div
                key={order.id}
                className="order-summary"
                onClick={() =>
                  setExpandedOrder(expandedOrder === index ? null : index)
                }
              >
                <div className="order-header">
                  <div className="order-info">
                    <p>
                      <strong>کد پیگیری:</strong>{" "}
                      {convertToPersianNumbers(order.tracking_code)}
                    </p>
                    <p>
                      <strong>قیمت کل سفارش:</strong>{" "}
                      {convertToPersianNumbers(order.sum_price)} ریال
                    </p>
                    <p>
                      <strong>وضعیت سفارش:</strong> ثبت شده
                    </p>
                  </div>
                  <div className="toggle-icon">
                    {expandedOrder === index ? (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="#333"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 4L10 8L6 12"
                          stroke="#333"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {expandedOrder === index && (
                  <div className="order-details">
                    <h4>اقلام سفارش:</h4>
                    {order.orderItem.map((item) => (
                      <div key={item.id} className="order-item">
                        <p>{item.product}</p>
                        <p>تعداد: {convertToPersianNumbers(item.quantity)}</p>
                        <p>قیمت: {convertToPersianNumbers(item.price)} ریال</p>
                        <p>رنگ: {item.color_product}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>سفارشی وجود ندارد.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
